let identifier = 0

export function generateUniqueId(): string {
  let unique = 'video-' + Date.now() + ++identifier
  while (document.getElementById(unique)) {
    unique = 'video-' + Date.now() + ++identifier
  }
  return unique
}
